import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeliveryRateModal from '../../AddOrUpdate/components/DeliveryRateModal';
import RadioSelectTable from 'src/shared/components/table/RadioSelectTable';

const DeliveryRateDetailsView = ({ reactTableData, data, isNoRecordFound, onAdd }) => {
  const rows = reactTableData?.tableRowsData ?? [];
  const [selectedRate, setSelectedRate] = useState(rows.length > 0 ? rows[0] : null);

  const RATE_COLUMNS = [
    { key: 'areaName', header: 'Area Name', sortable: true },
    { key: 'areaCode', header: 'Area Code', sortable: true },
    { key: 'rate', header: 'Rate (AED)', sortable: true },
  ];

  return (
    <Col md={12} lg={12} style={{ marginTop: '20px' }}>
      <Row>
        {/* Left: Master List */}
        <Col md={7} lg={7}>
          <RadioSelectTable
            rows={rows}
            columns={RATE_COLUMNS}
            rowKey="deliveryAreaId"
            selectedKey={selectedRate?.deliveryAreaId}
            onSelect={setSelectedRate}
            searchKeys={['areaName', 'areaCode']}
            searchPlaceholder="Search by Area Name, Code..."
            sortKey="areaName"
            headerTitle="Delivery Rates"
            onAdd={onAdd}
            pageSizes={[5, 10, 20, 50]}
          />
        </Col>
        {/* Right: Detail Panel */}
        <Col md={5} lg={5}>
          <Card style={{
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
            minHeight: '520px',
            background: '#ffffff',
            overflow: 'hidden',
          }}>
            {selectedRate ? (
              <>
                <div style={{ background: 'linear-gradient(135deg, #475569 0%, #1e293b 100%)', padding: '24px 20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <h4 style={{ margin: 0, fontWeight: 800, fontSize: '1.2rem', color: '#ffffff' }}>{selectedRate.areaName}</h4>
                    </div>
                  </div>
                </div>
                <CardBody style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div>
                      <h6 className="text-muted text-uppercase fw-bold mb-2" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Details</h6>
                      <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '12px 14px', border: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Area Code:</span>
                          <span className="fw-bold small text-dark">{selectedRate.areaCode}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Rate (AED):</span>
                          <span className="fw-bold small text-dark">{selectedRate.rate}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px', textAlign: 'center', minHeight: '520px' }}>
                <div style={{ fontSize: '3.5rem', color: '#cbd5e1', marginBottom: '16px' }}>📦</div>
                <h5 className="fw-bold text-muted">No Rate Selected</h5>
                <p className="text-muted small">Select a delivery rate from the list to view details.</p>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Col>
  );
};

DeliveryRateDetailsView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default DeliveryRateDetailsView;
